import { FaTiktok, FaTwitch, FaTelegram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
const Footer = () => {
  const socialLinks = [{
    icon: FaTiktok,
    url: "https://www.tiktok.com/@mysteryseie?_r=1&_t=ZM-91LRvcFqMVE",
    label: "TikTok"
  }, {
    icon: FaTwitch,
    url: "https://www.twitch.tv/atlasai_markets",
    label: "Twitch"
  }, {
    icon: FaXTwitter,
    url: "https://x.com/8atlas_ai?s=21",
    label: "X (Twitter)"
  }, {
    icon: FaTelegram,
    url: "https://t.me/atlasaimakets",
    label: "Telegram"
  }];
  return <footer className="border-t border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand & Contact */}
          <div>
            <h3 className="font-semibold text-foreground mb-3">AtlasAI (Beta)</h3>
            <p className="text-sm text-muted-foreground mb-2">
              AI-powered market analysis for smarter trading decisions
            </p>
            <a href="mailto:support@atlasai.markets" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
              <Mail className="h-4 w-4" />
              support@atlasai.markets
            </a>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-semibold text-foreground mb-3">Follow Us</h3>
            <div className="flex gap-4">
              {socialLinks.map(social => <a key={social.label} href={social.url} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label={social.label}>
                  <social.icon className="h-5 w-5" />
                </a>)}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-border/40 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} AtlasAI. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;